class RatingWidget {
	constructor (wrapper) {
		this.widget = $(wrapper);
		this.data   = null;

		this.attachEvents();
	}

	attachEvents () {
		let self = this;

		this.widget.on('click', '.js-rate-idea', function (e) {
			e.preventDefault();

			self.queueAjaxCallback(this);

			return false;
		});

		this.widget.mouseleave(function () {
			// Only process the queued callback if the main widget is the target.
			if (self.data !== null) {
				self.processCallback();
			}
		});
	}

	queueAjaxCallback (link) {
		let el = $(link);

		// Push the href/fields for the onMouseOut handler...
		this.data = {
			href: link.href,
			fields: {
				stars: el.data('stars')
			}
		};
	}

	processCallback () {
		// Pull a local copy of the data, and reset it; prevent multiple calls on multiple mouse in/out calls.
		let data  = this.data;
		this.data = null;

		let wrapper = this.widget;
		let bar = wrapper.find('.js-idea-rating');

		axios.post(data.href, data.fields)
			.then(function (response) {
				if (response.status !== 200) {
					return;
				}

				let avg = parseFloat(response.data.avg);

				wrapper.attr('title', 'Average Rating: ' + avg.toFixed(2) + ' stars (' + response.data.count + ' votes)');

				bar.css('width', (avg * 100 / 5).toFixed(1) + '%');
			});
	}
}

module.exports = RatingWidget;